import { render, staticRenderFns } from "./ProposalActivityForm.vue?vue&type=template&id=ac44e154&"
import script from "./ProposalActivityForm.vue?vue&type=script&lang=js&"
export * from "./ProposalActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports